<template>
  <div class="main-login h5-auth-page h5-register-page">
    <div class="main-login-head">
      <button type="button" class="login-brand" data-track-id="h5.register.brand-home" data-track-text="返回首页" aria-label="返回首页" @click="$router.push('/index')">
        <img src="@/assets/v2/img/index/wiseivy-mark.png" alt="微思学术 Logo">
        <span>微思学术</span>
      </button>
      <div class="login-hero-copy">
        <span>WISETRANS</span>
        <strong>创建账号，开启专业翻译</strong>
        <p>安全、高效、便捷的一站式翻译服务</p>
      </div>
    </div>
    <div class="main-login-form">
      <div class="main-login-form-head">
        <div class="main-login-form-pass" :style="'font-size: 36px;'">
          用户注册
          <div class="check" :style="'background: var(--primary-dark);'"></div>
        </div>
      </div>
      <div class="main-login-form-input">
        <el-form :model="from" :rules="login_rules" ref="loginRef"
                 label-width="0px" class="demo-ruleForm">
          <el-form-item prop="username">
            <el-input placeholder="请输入账号：*仅支持英文、数字、下划线" v-model="from.username"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input placeholder="请输入密码" type="password" v-model="from.password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input autocomplete="off"
                      placeholder="请输入手机号" v-model="from.phone"
            ></el-input>
          </el-form-item>
          <el-form-item class="captcha-item" prop="validate">
            <el-input placeholder="请输入验证码" v-model="from.validate" style="width: 475px"
            ></el-input>
            <img style="float: right;width: 133.5px;height: 62px;font-family: Noto Sans S Chinese !important;"
                 :src="qrcodeUrl" alt="验证码加载失败..."
                 data-track-text="刷新图形验证码"
                 aria-label="刷新图形验证码"
                 @click="getValicode"/>
          </el-form-item>
          <el-form-item class="phone-code-item" prop="phoneValidate">
            <el-input placeholder="请输入6位验证码" v-model="from.phoneValidate" style="width: 475px"
            ></el-input>
            <div class="timeButton" v-show="Verification" data-track-text="H5注册获取动态密码" aria-label="H5注册获取动态密码" @click="handleTimeClick">获取动态密码</div>
            <div class="timeButtonClick" v-show="!Verification">{{timers}}秒后重新获取</div>
          </el-form-item>
          <div class="form-message" v-if="messages!==''">{{ messages }}</div>
          <el-form-item class="agreement-item" style="margin-bottom: 0;margin-top: 80px;">
            <div style="float: left;cursor:pointer;font-size: 22px;font-family: Adobe Heiti Std;font-weight: normal;color: #999999;">
              <el-checkbox v-model="checked">我已阅读并同意遵守</el-checkbox>
              <span style="color: #1B4FA7;font-family: Noto Sans S Chinese !important;"
                    data-track-text="H5注册查看用户服务协议"
                    aria-label="H5注册查看用户服务协议"
                    @click="openAgreement">《用户服务协议》</span>
            </div>
            <div style="float: right;cursor:pointer;font-size: 22px;font-family: Adobe Heiti Std;font-weight: normal;color: #1C50A7;"
                 data-track-text="H5注册返回登录"
                 aria-label="H5注册返回登录"
                 @click="toLogin">已有账号，立即登录
            </div>
          </el-form-item>
          <el-form-item class="login_button">
            <el-button type="primary" data-track-text="H5提交注册" aria-label="H5提交注册" @click="submitRegisterFrom()">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>


import {authServiceClient} from "@/tools/api/service";
import {
  checkPhoneRequest,
  checkUserNameRequest,
  phoneCodeRequest,
  registerRequest,
  valicodeRequest
} from "@/tools/api/auth-api";

export default {
  name: "Register",
  data() {
    return {
      checked: false,
      timers: 60,
      Verification: true,
      qrcodeUrl:"",
      messages:'',
      isLogin: false,
      from: {
        username: "",
        password: "",
        validate: "",
        phoneValidate: "",
        phone: ""
      },
      login_rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'},
          {validator: this.validateName, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'}
        ],
        validate: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[0-9]{10}$/, message: "请输入合法手机号/电话号", trigger: "blur"},
          {validator: this.validatePhone, trigger: 'blur'}
        ],
        phoneValidate: [
          {validator: this.validatePhoneCode, trigger: 'blur'}
        ]
      },
    }
  },
  created() {
    this.getValicode();
  },
  methods: {
    toLogin() {
      this.$router.push("/h5/login")
    },
    openAgreement() {
      window.open("/agree");
    },
    handleTimeClick() {
      this.$refs.loginRef.validate((valid) => {
        if (!valid) {
          return;
        }
        const that = this;
        let request = phoneCodeRequest;
        request.setCode(this.from.validate)
        request.setPhone(this.from.phone)
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(CODE_KEY)) {
          metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
        } else {
          metadata = {}
        }
        authServiceClient.sendPhoneCode(request, metadata)
            .then(res => {
              if (res.getStatus()) {
                that.messages = "";
                that.Verification = false;
                this.auth_timer = setInterval(() => {
                  that.timers--;
                  if (that.timers <= 0) {
                    that.Verification = true;
                    that.timers = 60;
                    clearInterval(that.auth_timer)
                  }
                }, 1000)
                return;
              }
              that.getValicode();
              that.messages = "验证码错误"
              that.Verification = true;
              that.timers = 60;
            }).catch(err => {
          that.getValicode();
          that.messages = "手机验证码发送失败"
          that.Verification = true;
          that.timers = 60;
        });
      });
    },
    submitRegisterFrom() {
      const that = this;
      this.isLogin = true;
      this.$refs.loginRef.validate((valid) => {
        if (!valid) {
          this.isLogin = false;
          return false;
        }
        if (!that.checked) {
          that.messages = "请阅读并同意协议";
          this.isLogin = false;
          return false;
        }
        let request = registerRequest;
        request.setUsername(that.from.username);
        request.setPassword(that.from.password);
        request.setValicode(that.from.validate);
        request.setPhone(that.from.phone + "");
        request.setPhonecode(that.from.phoneValidate);
        const TOKEN_KEY = 'token';
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }
        } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else {
          metadata = {}
        }
        authServiceClient.userRegister(request, metadata).then(res => {
          if (res.getStatus() === 0) {
            that.$message({
              center: true,
              type: 'success',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            });
            that.$router.push("/h5/login");
            return;
          }
          this.isLogin = false;
          that.messages = res.getMessage();
          this.getValicode();
        }).catch(err => {
          if (err && err.code === 5) {
            this.$router.push("/h5/register").catch(() => {})
          }
          this.isLogin = false;
        })
      })
      this.isLogin = false;
    },
    validatePhoneCode(rule, value, callback) {
      if (!this.isLogin) {
        callback()
        return
      }
      if (value === null || value === undefined || value === "") {
        callback(new Error('请输入手机验证码'))
        return;
      }
      if (value.length > 6 || value.length < 6) {
        callback(new Error('请输入6位手机验证码'))
        return;
      }
      callback()
    },
    validatePhone(rule, value, callback) {
      let request = checkPhoneRequest;
      request.setPhone(value);
      authServiceClient.checkPhone(request, null).then(res => {
        if (res.getStatus() === 3) {
          callback();
          return;
        }
        callback(new Error('手机号已注册'))
      }).catch(err => {
        callback(new Error('校验出错'));
      })
    },
    validateName(rule, value, callback) {
      if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        callback(new Error('用户名不能含有汉字'));
        return;
      }
      if (/.*[`~!#$^&*()=|{}':;',\[\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]+.*$/.test(value)) {
        callback(new Error('用户名不能包含特殊字符'));
        return;
      }
      let request = checkUserNameRequest;
      request.setUsername(value);
      authServiceClient.checkUserName(request, null).then(res => {
        if (res.getStatus() === 3) {
          callback();
          return;
        }
        callback(new Error('用户名已注册'))
      }).catch(err => {
        callback(new Error('校验出错'));
      })
    },
    getValicode() {
      const CODE_KEY = 'code';
      let metadata;
      if (localStorage.getItem(CODE_KEY)) {
        metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
      } else {
        metadata = {}
      }
      authServiceClient.getValicode(valicodeRequest, metadata).then(res => {
        this.qrcodeUrl = 'data:image/gif;base64,' + res.toObject().valicodeImage;
      })
    },
  }
}
</script>

<style lang="less" scoped>
.timeButton {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #efeded;
  font-size: 21px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  color: #333333;
  display: flex;
  justify-content: center;
}

.timeButtonClick {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #1c50a7;
  font-size: 18px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  display: flex;
  justify-content: center;
  color: #ffffff;
}

.main-login {
  min-width: 765px;
  width: 100%;
  height: 1315px;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;

  .main-login-head {
    width: 100%;
    height: 420px;
    background: url("../../assets/H5/nh.png") no-repeat #1C50A7;
    background-position: center;
    background-size: contain;
  }

  .main-login-form {
    margin-top: -71px;
    width: 704px;
    height: 1008px;
    background: #FFFFFF;

    .main-login-form-head {
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 56px;
      text-align: center;
      margin-top: 50px;
      display: flex;
      justify-content: center;
      align-items: center;

      .main-login-form-pass {
        cursor: pointer;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;

        .check {
          width: 64px;
          height: 4px;
          margin-top: 15px;
        }
      }
    }

    .main-login-form-input {
      margin-top: 61px;
      width: 625px;
      display: flex;
      justify-content: center;

      /deep/ .demo-ruleForm {
        .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
          height: 65px;
          border: 1px solid #FBAFAF;
          box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
          border-radius: 3px;
        }

        .el-checkbox{
          font-size: 22px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #999999;
          span{
            font-size: 22px;
          }
        }
        .el-checkbox__inner::after {
          box-sizing: content-box;
          content: "";
          border-left: 0;
          border-top: 0;
          height: 7px;
          left: -39px;
          position: absolute;
          top: 9px;
          transform: rotate(45deg) scaleY(0);
          width: 34px;
          transform-origin: center;
        }
        .el-checkbox__input.is-checked+.el-checkbox__label {
          color: rgb(27, 79, 167);
        }
        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: rgb(27, 79, 167);;
          border-color: rgb(27, 79, 167);;
        }
        .el-checkbox__inner{
          width: 30px;
          height: 30px;
          border: 1px solid #DDDDDD;
          border-radius: 3px;
        }
        .el-button--primary {
          width: 624px;
          height: 70px;
          background: #184482;
          border-radius: 3px;
          margin-top: 31px;
          font-size: 30px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #FFFFFF;
        }

        .el-form-item__error {
          color: #F56C6C;
          font-size: 20px;
          line-height: 1;
          padding-top: 4px;
          position: absolute;
          top: 100%;
          left: 0;
        }

        .el-form-item {
          margin-bottom: 31px;
        }

        .el-form-item__content {
          margin-left: 76px !important;
        }

        .el-input {
          height: 65px;
          width: 625px;

          .el-input__inner {
            height: 65px;
            border: 1px solid #DDDDDD;
            box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
            border-radius: 3px;
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less" src="../../assets/h5-auth.less"></style>
